export const modalTheme = {
  titleFontSize: 20,
  fontFamily: "RedHatDisplayMedium",
  fontWeightStrong: 700,
};
